<template>
  <pages-wrapper>
    <div class="returns-page">
      <h1 class="returns-title">
        {{ pageTitle }}
      </h1>

      <fragment
        prefetch
        slot-name="return_page_header"
      />

      <ui-tabs
        v-model="tab"
        :items="tabs"
      />
    </div>
  </pages-wrapper>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
/* Components */
import PagesWrapper from '../../components/info-pages/pages-wrapper';
import sizesImg from '../../assets/images/sizes.jpg';
import Fragment from '../../components/info-pages/fragment';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'returns',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    Fragment,
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      pageTitle: 'Обмен и возврат',
      tab: 'pickup',
      sizesImage: sizesImg
    }
  },

  computed: {
    ...mapGetters({
      PAGE_CONTENT: 'staticPages/page',
      GET_FRAGMENT: 'staticPages/fragments',
    }),

    tabs() {
      return [
        {
          key: 'pickup',
          name: 'Возврат в розничный магазин',
          content: this.GET_FRAGMENT(this.activeSlot),
          contentClass: '',
        },
        {
          key: 'parcel',
          name: 'Возврат по почте',
          content: this.GET_FRAGMENT(this.activeSlot),
          contentClass: '',
        },
      ];
    },

    activeSlot() {
      switch(this.tab) {
        case 'pickup':
          return 'return_page_pickup';
        case 'parcel':
          return 'return_page_parcel';
        default:
          return '';
      }
    }
  },

  watch: {
    tab() {
      if (this.GET_FRAGMENT(this.activeSlot)) return;

      this.LOAD_FRAGMENT({slotName: this.activeSlot});
    }
  },



  methods: {
    ...mapActions({
      LOAD_FRAGMENT: 'staticPages/loadStaticFragments'
    })
  },

  serverPrefetch() {
    return this.LOAD_FRAGMENT({slotName: this.activeSlot});
  }
};
</script>

<style lang="scss">
.returns-page {
  p {
    margin-top: 24px;
  }

  .ui-tabs-wrapper {
    & > ul {
      padding: 0 16px;

      & li {
        margin-top: 0;
        font-size: 14px;
        line-height: 20px;
      }

      & > li::before,
      & > li::after {
        content: none;
      }
    }
  }

  .order-support {
    margin-top: 12px;
    color: $black;
  }
}

@include breakpoint("tablet") {
  .returns-page {
    p {
      margin-top: 32px;
    }
  }
}

@include breakpoint("desktop") {
  .returns-page {
    .ui-tabs-wrapper {
      & > ul {
        padding: 0;

        & > li {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    .order-support {
      margin-top: 16px;
    }
  }
}
</style>
